import { render, staticRenderFns } from "./AppViewAs.vue?vue&type=template&id=81168520&"
import script from "./AppViewAs.vue?vue&type=script&lang=js&"
export * from "./AppViewAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports